import { APPLICATION_STATUS } from "../UI_V2_Components/jobsPortal/constants";

export const segregateJobs = (arr = [], useApplicationTrackingUI = false) => {
  if (useApplicationTrackingUI) {
    return segregateJobsV2(arr);
  }
  const active = arr.filter((job) =>
    ["VIEWED", "JRF_SUBMITTED"].includes(job.status)
  );
  const submitted = arr.filter((job) => {
    const filters = ["APPLIED", "APPLICATION_WITHDRAWN", "VETSMITH_FAILED"];
    return filters.includes(job.status);
  });
  const recommended = arr.filter((job) => job.status === "TODO");
  return {
    active,
    recommended,
    submitted,
    archived: [],
  };
};

const segregateJobsV2 = (arr) => {
  const recommended = arr.filter((job) => job.status === "TODO");
  const active = arr.filter((job) => [APPLICATION_STATUS.SUBMIT_ICF, APPLICATION_STATUS.TAKE_VETTING, APPLICATION_STATUS.COMPLETE_VETTING].includes(job.applicationStatus));
  const submitted = arr.filter((job) => [APPLICATION_STATUS.SUBMITTED, APPLICATION_STATUS.IN_REVIEW, APPLICATION_STATUS.REVIEW_COMPLETED, APPLICATION_STATUS.SHORTLISTED, APPLICATION_STATUS.SELECTED, APPLICATION_STATUS.SELECTED_FOR_ANOTHER_JOB].includes(job.applicationStatus));
  const archived = arr.filter((job) => job.applicationStatus === APPLICATION_STATUS.ARCHIVED);
  return {
    active,
    submitted,
    archived,
    recommended,
  };
};
